import { Address } from "address-lookup";

export type ManualEntryAddressProps = Omit<Address, "unitType"> & {
  unitType?: {
    label: string;
    value: string;
  };
};

export const combineManualEntryToAddress = (
  address: ManualEntryAddressProps
): string => {
  const {
    unitType,
    unitNumber,
    streetNumber,
    streetName,
    streetType,
    city,
    state,
    postcode,
  } = address;
  const streetTypeDisplay = streetType ? ` ${streetType}` : "";

  let result = `${streetNumber} ${streetName}${streetTypeDisplay}, ${city.toUpperCase()} ${state.toUpperCase()} ${postcode}`;

  if (unitType?.label && unitNumber) {
    result = `${unitType.label} ${unitNumber} ${result}`;
  }

  return result.trim();
};
